import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=285e8d2c&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=ts&"
export * from "./ClientList.vue?vue&type=script&lang=ts&"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=285e8d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e8d2c",
  null
  
)

export default component.exports